import { PlacementInstruction } from '../../shared/types/reklameMaster';
import { MessageBus } from '@podium/browser';
import { events } from '@schibsted-nmp/advertising-events';
import { renderPlacement } from '../components/placement';
import { getConfig } from '../config';

export function getType(index: number) {
    const config = getConfig();
    const hasContentMarketing = config?.contentMarketing?.length > 0;
    if (hasContentMarketing && index === 1) {
        return 'content-marketing';
    }

    return 'ast';
}

export function companionReadyPlacementListener(
    placementInstruction: PlacementInstruction[],
) {
    const messageBus = new MessageBus();

    messageBus.publish(
        events.COMPANION.channel,
        events.COMPANION.PODLET_READY.topic,
        {
            placementInstructionConfigs: [
                {
                    type: 'search',
                    data: placementInstruction,
                },
            ],
        },
    );

    messageBus.subscribe(
        events.COMPANION.channel,
        events.COMPANION.PLACEMENT_READY.topic,
        (event) => {
            const payload = events.COMPANION.PLACEMENT_READY.getPayload(event);

            if (payload?.containerId) {
                renderPlacement(payload.containerId, {
                    id: payload.placementId,
                    grid: payload.cols !== 1,
                    showBanners: true,
                    type: getType(payload.adIndex),
                });
            }
        },
    );
}
